module.exports = __webpack_public_path__ + "media/images/logo-9436610a58907b13375e393163d37a53.svg";